import { combineReducers } from "redux";
import * as isLoading from "./isLoadingShareCount";
import * as shareCount from "./shareCount";

export const initialState = {
  isLoading: isLoading.initialState,
  shareCount: 0,
};

export const reducer = combineReducers({
  isLoadingShareCount: isLoading.reducer,
  shareCount: shareCount.reducer,
});

export interface StoreState {
  isLoadingShareCount: isLoading.StoreState;
  shareCount: shareCount.StoreState;
}
